import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
	selector: 'checklist-progress',
	imports: [CommonModule, MatIconModule],
	templateUrl: './checklist-progress.component.html',
	styleUrls: ['./checklist-progress.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChecklistProgressComponent {
	@Input({ required: true }) totalCount: number = 0;
	@Input() completedCount: number = 0;

	get percentage(): number {
		return this.totalCount > 0
			? Math.round((this.completedCount / this.totalCount) * 100)
			: 0;
	}
}
